import React from 'react'
import { Box } from "@mui/material";
import Side from "../../../assets/home/sidebar/side.png";
import Dp from "../../../assets/home/sidebar/dp.png";
import twitter from "../../../assets/home/sidebar/twitter-logo.png";
import instagram from "../../../assets/home/sidebar/instagram-logo.png";
import facebook from "../../../assets/home/sidebar/facebook-logo.png";
import messages from "../../../assets/home/sidebar/messages.png";
import call from "../../../assets/home/sidebar/call.png";
import calender from "../../../assets/home/sidebar/calendar.png";

const profile = () => {
  return (
    <>
         <Box className="profile-container br-16">
              <Box className="dp-img br-16" position="relative">
                <img src={Side} alt="" className='dp-img-bg' />
                <div className="user-img flex-center-center">
                  <img src={Dp} />
                </div>
              </Box>
              <div className="user-avatar flex-center-between">
                <div className="social-links d-flex">
                  <img src={twitter} />
                  <img src={instagram} />
                  <img src={facebook} />
                </div>
              </div>
              <div className="user-info">
                <div  className='flex-center-between'>
                <h2>Eva Smith</h2>
                  <div>
                  <img src={twitter} alt="" />
                  <img src={instagram} alt="" />
                    <img src={facebook} alt="" />
                  </div>
                </div>
                <div className="user-ifo-icon">
                  <img src={messages} />
                  <p>evasmith@gmail.com</p>
                </div>
                <div className="user-ifo-icon">
                  <img src={call} />
                  <p>+923018089436</p>
                </div>
                <div className="user-ifo-icon">
                  <img src={calender} />
                  <p>4 June, 2020</p>
                </div>
              </div>
              <button className="admit-button">Profile</button>
            </Box>
    </>
  )
}

export default profile
